module.exports = __webpack_public_path__ + "static/img/zhihui-1.e204a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhihui-1.png
// module id = WKu3
// module chunks = 46